export const DISTRIBUTION_LIST_MOCK = [
  {
    date: '2024-02-02',
    name: 'Prosumer 1',
    surname: '',
    amount: 215.2,
    reason: 'Acconto gennaio 2024',
  },
  {
    date: '2024-02-02',
    name: 'Consumer 1',
    surname: '',
    amount: 172.13,
    reason: 'Acconto gennaio 2024',
  },
  {
    date: '2024-02-02',
    name: 'Consumer 2',
    surname: '',
    amount: 87.17,
    reason: 'Acconto gennaio 2024',
  },
  {
    date: '2024-02-02',
    name: 'Prosumer 2',
    surname: '',
    amount: 423.75,
    reason: 'Acconto gennaio 2024',
  },
  {
    date: '2024-02-01',
    name: 'Consumer 1',
    surname: '',
    amount: 40,
    reason: 'Saldo gennaio 2023',
  },
  {
    date: '2023-02-01',
    name: 'Prosumer 1',
    surname: ' ',
    amount: 190,
    reason: 'Saldo gennaio 2023',
  },
  {
    date: '2023-02-01',
    name: 'Consumer 2',
    surname: '',
    amount: 62,
    reason: 'Saldo gennaio 2023',
  },
  {
    date: '2023-02-01',
    name: 'Prosumer 2',
    surname: '',
    amount: 276,
    reason: 'Saldo gennaio 2023',
  },

  {
    date: '2024-01-05',
    name: 'Consumer 1',
    surname: '',
    amount: 320,
    reason: 'Acconto dicembre 2023',
  },
  {
    date: '2024-01-05',
    name: 'Prosumer 1',
    surname: '',
    amount: 430,
    reason: 'Acconto dicembre 2023',
  },
  {
    date: '2024-01-05',
    name: 'Consumer 2',
    surname: '',
    amount: 290,
    reason: 'Acconto dicembre 2023',
  },
  {
    date: '2024-01-05',
    name: 'Prosumer 2',
    surname: '',
    amount: 537,
    reason: 'Acconto dicembre 2023',
  },
];
